import React from 'react';
import { WixDesignSystemProvider } from '@wix/design-system';

import App from './App';
import { ExperimentsProvider } from '../../contexts/ExperimentsContext';
import { TemplatesPageUIProvider } from '../../contexts/TemplatesPageUIContext';

export default (props: any) => {
  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <ExperimentsProvider>
        <TemplatesPageUIProvider>
          <App {...props} />
        </TemplatesPageUIProvider>
      </ExperimentsProvider>
    </WixDesignSystemProvider>
  );
};
